module.exports = __webpack_public_path__ + "img/download-right-bg.6d1afd42.jpg";